// Module
var code = "<md-content> <tri-menu-item ng-repeat=\"item in $ctrl.menu | orderBy:'priority'\" item=\"::item\" permission permission-only=\"item.permission\"> </tri-menu-item> </md-content> ";
// Exports
export default code;